export default "__VITE_ASSET__DH5NRJwL__"